import { page } from "@routes/routeModule";
import LangContextProvider from "@context/Lang/LangContextProvider";
import { Navigate, Outlet, Route } from "react-router";
import {
  LOGIN,
  OAUTH_GOOGLE_LOGIN_CLINICS,
  LOGIN_GOOGLE_NO_ACCOUNT_ERROR,
  LOGIN_SELECT_ACCOUNT,
  LOGIN_TWO_FACTOR,
  PASSWORD_REMIND,
  PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_STORE,
  PASSWORD_STORE_SUCCESS,
  PATIENT_PASSWORD_RESET,
  PATIENT_PASSWORD_STORE,
  REGISTER,
  REGISTER_CLINIC,
  REGISTER_GOOGLE,
  REGISTER_NEW,
  REGISTER_SUCCESS,
  REJESTRACJA,
} from "@routes/routes";

// Lazy-loaded auth pages
const ResetPasswordDietitianPage = page(
  () => import("@/packages/auth/ResetPassword/ResetPasswordDietitianPage"),
);
const StorePasswordDietitianPage = page(
  () => import("@/packages/auth/StorePassword/StorePasswordDietitianPage"),
);
const RemindPasswordPage = page(
  () => import("@/packages/auth/RemindPassword/RemindPasswordPage"),
);
const RegisterPage = page(
  () => import("@/packages/auth/Register/RegisterPage"),
);
const GoogleClinicRegisterPage = page(
  () => import("@/packages/auth/GoogleClinicRegister/GoogleClinicRegisterPage"),
);
const LoginPage = page(() => import("@/packages/auth/Login/LoginPage"));
const GoogleLoginNoAccountErrorPage = page(
  () =>
    import("@/packages/auth/GoogleLoginNoAccountError/GoogleLoginNoAccountErrorPage"),
);
const GoogleLoginSelectAccountPage = page(
  () =>
    import("@/packages/auth/GoogleLoginSelectAccount/GoogleLoginSelectAccountPage"),
);
const LoginSelectAccountPage = page(
  () => import("@/packages/auth/LoginSelectAccount/LoginSelectAccountPage"),
);
const LoginTwoFactorPage = page(
  () => import("@/packages/auth/LoginTwoFactor/LoginTwoFactorPage"),
);
const RegisterSuccessPage = page(
  () => import("@/packages/auth/Register/RegisterSuccessPage"),
);
const StorePasswordSuccessPage = page(
  () => import("@/packages/auth/StorePassword/StorePasswordSuccessPage"),
);
const ResetPasswordSuccessPage = page(
  () => import("@/packages/auth/ResetPassword/ResetPasswordSuccessPage"),
);
const StorePasswordPatientPage = page(
  () => import("@/packages/auth/StorePassword/StorePasswordPatientPage"),
);
const ResetPasswordPatientPage = page(
  () => import("@/packages/auth/ResetPassword/ResetPasswordPatientPage"),
);

export const authRoutes = (
  <Route
    element={
      <LangContextProvider>
        <>
          <Outlet />
        </>
      </LangContextProvider>
    }
  >
    <Route path={PASSWORD_RESET} lazy={ResetPasswordDietitianPage} />
    <Route path={PASSWORD_RESET_SUCCESS} lazy={ResetPasswordSuccessPage} />
    <Route path={PATIENT_PASSWORD_RESET} lazy={ResetPasswordPatientPage} />
    <Route path={PASSWORD_STORE} lazy={StorePasswordDietitianPage} />
    <Route path={PASSWORD_STORE_SUCCESS} lazy={StorePasswordSuccessPage} />
    <Route path={PATIENT_PASSWORD_STORE} lazy={StorePasswordPatientPage} />
    <Route path={PASSWORD_REMIND} lazy={RemindPasswordPage} />
    <Route path={REJESTRACJA} lazy={RegisterPage} />
    <Route path={REGISTER_NEW} lazy={RegisterPage} />
    {/* /auth/registerAPI was the (broken) public URL between 2026-05 and 2026-07 — keep links alive */}
    <Route
      path="/auth/registerAPI"
      element={<Navigate to={REGISTER_NEW} replace />}
    />
    <Route path={REGISTER_CLINIC} lazy={RegisterPage} />
    <Route path={REGISTER} lazy={RegisterPage} />
    <Route path={REGISTER_SUCCESS} lazy={RegisterSuccessPage} />
    <Route path={REGISTER_GOOGLE} lazy={GoogleClinicRegisterPage} />
    <Route path={LOGIN} lazy={LoginPage} />
    <Route path={LOGIN_SELECT_ACCOUNT} lazy={LoginSelectAccountPage} />
    <Route path={LOGIN_TWO_FACTOR} lazy={LoginTwoFactorPage} />
    <Route
      path={LOGIN_GOOGLE_NO_ACCOUNT_ERROR}
      lazy={GoogleLoginNoAccountErrorPage}
    />
    <Route
      path={OAUTH_GOOGLE_LOGIN_CLINICS}
      lazy={GoogleLoginSelectAccountPage}
    />
  </Route>
);
